<template>
  <div class="createbrand">
    <r-modal
      v-if="showCreateBrandModal"
      :title="$t('createBrand.label')"
      close-action-label="Cancel"
      :action-label="$t('createBrand.label')"
      :fetching="fetchingCreateBrand"
      :action-disabled="!(name && color)"
      @close="onClickCancel"
      @submit="onClickSave"
    >
      <template v-slot:content>
        <v-form
          ref="form"
          v-model="valid"
          class="createbrandform mt-5"
        >
          <v-row
            class="mt-5"
            no-gutters
          >
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <r-text-field
                class="input-text createbrandform--name"
                :value="name"
                :label="$t('createBrand.fields.name')"
                placeholder="Lorem ipsum"
                :rules="[rules.required]"
                @change="onNameInputChange"
              />
            </v-col>
          </v-row>
          <span>
            {{ $t('createBrand.fields.color') }}
          </span>
          <color-picker
            :show-color-picker="showColorPicker"
            @select:custom-color="onSelectCustomColor"
          />
          <v-row
            no-gutters
          >
            <v-col
              class="createbrandform--colors"
            >
              <div
                v-for="(color, i) in colors"
                :key="i"
                :colors="colors"
                :color="color"
                class="createbrandform--color"
                :class="{'selected': $data.color === color && !showColorPicker}"
                :style="'background:'+color"
                @click="onSelectColor(color)"
              />
              <div
                class="createbrandform--color-picker"
                :class="{'selected': showColorPicker}"
                :color="color"
                @click="onSelectColorPicker"
              />
            </v-col>
          </v-row>
        </v-form>
        <r-error-message
          :errors="[fetchCreateBrandError]"
        />
      </template>
    </r-modal>
  </div>
</template>

<script>
import RModal from '@/components/library/organisms/RModal.vue'
import RTextField from '@/components/library/molecules/RTextField'
import RErrorMessage from '@/components/library/atoms/RErrorMessage'
import { GROUPING_COLORS } from '@/utils/constants'
import { mapActions, mapState } from 'vuex'
import ColorPicker from './ColorPicker.vue'

export default {
  name: 'CreateBrand',
  components: {
    RModal,
    RTextField,
    RErrorMessage,
    ColorPicker,
  },
  props: {
    showCreateBrandModal: {
      type: Boolean,
      default: false,
    },
    fetchingCreateBrand: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    name: '',
    color: '',
    valid: false,
    colors: GROUPING_COLORS,
    rules: {
      required: (v) => !!v || 'Brand name should be provided',
    },
    showColorPicker: false,
  }),
  computed: {
    ...mapState('brands', [
      'fetchCreateBrandError',
    ]),
  },
  watch: {
    showCreateBrandModal() {
      if (!this.showCreateBrandModal) {
        this.$data.name = ''
        this.$data.color = ''
      }
    },
  },
  methods: {
    ...mapActions('brands', [
      'clearErrors',
    ]),
    onNameInputChange({ value }) {
      this.name = value?.trim()
    },
    setColor(color) {
      if (color !== this.color) {
        this.color = color
      }
    },
    onSelectColor(color) {
      this.showColorPicker = false
      this.setColor(color)
    },
    onSelectCustomColor({ color }) {
      this.setColor(color)
    },
    onSelectColorPicker() {
      this.showColorPicker = true
    },
    onClickSave() {
      this.clearErrors({ fetchCreateBrandError: '' })
      this.$emit('submit:create-brand', { value: { name: this.name, color: this.color } })
    },
    onClickCancel() {
      this.clearErrors({ fetchCreateBrandError: '' })
      this.$emit('close')
    },
  },
}
</script>

<style scoped>
  .createbrandform--colors {
    display: grid;
    margin: 15px auto;
    gap: 16px;
    grid-template-columns: repeat(9, 16px);
  }
  .createbrandform--color {
    border-radius: 50%;
    height: 16px;
    cursor: pointer;
  }
  .createbrandform--color.selected,
  .createbrandform--color-picker.selected {
    border: 2px solid var(--primary-color);
  }
  .createbrandform--color-picker {
    background-color: '#FFF';
    border: 1px solid var(--r-border-color);
    border-radius: 50%;
    position: relative;
    cursor: pointer;
  }
  .createbrandform--color-picker::after {
    border-bottom: 1px solid red;
    width: 50%;
    transform: rotate(135deg);
    content: " ";
    position: absolute;
    top: 50%;
    width: 100%;
  }
  .rbutton {
    min-width: 150px !important;
  }
</style>
